import type { AppProps } from "next/app";

export const getUID = function (router: AppProps["router"]) {
  if (router.query?.["uid"]) {
    return router.asPath.replace("/", "");
  }
  return router.pathname.replace("/", "");
};
